import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import store from '@/vuex/store.js'   //vuex
import api from '@/http/api.js'       //http请求
import Mint from 'mint-ui';    //移动端UI
import 'mint-ui/lib/style.css'
import VueClipboard from 'vue-clipboard2';
import config from "./util/config";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


Vue.use(Mint, {
  lazyload: {
    loading: config.loading,
  },
});
Vue.use(VueClipboard);
Vue.config.productionTip = false;
Vue.prototype.$api = api;
VueClipboard.config.autoSetContainer = true;
Vue.use(ElementUI);

// 设置cl值
// 台湾：tw_tc
// 泰国：th_th
// 马来(中文)：my_cn
// 马来(英文)：my_en
// 新加坡(中文)：sg_cn
// 新加坡(英文)：sg_en
// 香港(中文)：hk_tc
// 香港(英文)：hk_en
// 日本：jp_jp
// 阿联酋：ua_ar
// 沙特阿拉伯：sa_ar
// 罗马尼亚：ro_ro

const templateConfigs = {
  'tw_tc': {
    country: '台湾',
    stateSelect: true,
    citySelectInline: true,
    serviceLineMe: true,
    stateRequired: true,
    cityRequired: true,
    phoneRequired: true,
    nameRequired: true,
    autoFillProvince: '台湾'

  },
  'th_th': {
    country: '泰国',
    stateSelect: true,
    citySelect: true,
    thAddress: true,
    stateRequired: true,
    cityRequired: true,
    phoneRequired: true,
    nameRequired: true,
    autoFillProvince: '泰国'
  },
  'th_en': {
    country: '泰国',
    stateSelect: true,
    citySelect: true,
    thAddress: true,
    stateRequired: true,
    cityRequired: true,
    phoneRequired: true,
    nameRequired: true,
    autoFillProvince: '泰国'
  },
  'my_cn': {
    country: '马来西亚',
    stateSelect: true,
    citySelectInline: true,
    postalInput: true,
    postalRequired: true,
    stateRequired: true,
    cityRequired: true,
    phoneRequired: true,
    nameRequired: true,
    autoFillProvince: '马来西亚'
  },
  'my_en': {
    country: '马来西亚',
    stateSelect: true,
    citySelectInline: true,
    postalInput: true,
    postalRequired: true,
    stateRequired: true,
    cityRequired: true,
    phoneRequired: true,
    nameRequired: true,
    autoFillProvince: '马来西亚'
  },
  'ph_en': {
    country: '菲律宾',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    stateRequired: true,
    cityRequired: true,
    phoneRequired: true,
    nameRequired: true,
    postalInput: true,
    postalRequired: true
  },
  'sg_cn': {
    country: '新加坡',
    stateSelect: false,
    postalInput: true,
    postalRequired: true,
    phoneRequired: true,
    nameRequired: true,
    autoFillProvince: '新加坡',
    autoFillCity: '新加坡'
  },
  'sg_en': {
    country: '新加坡',
    stateSelect: false,
    postalInput: true,
    postalRequired: true,
    phoneRequired: true,
    nameRequired: true,
    autoFillProvince: '新加坡',
    autoFillCity: 'Singapore'
  },
  'hk_tc': {
    country: '香港',
    stateSelect: true,
    citySelectInline: true,
    streetSelect: true,
    stateRequired: true,
    cityRequired: true,
    phoneRequired: true,
    nameRequired: true,
  },
  'hk_en': {
    country: '香港',
    stateSelect: true,
    citySelectInline: true,
    streetSelect: true,
    stateRequired: true,
    cityRequired: true,
    phoneRequired: true,
    nameRequired: true,
  },
  'jp_jp': {
    country: '日本',
    stateSelect: true,
    cityInput: true,
    streetInput: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    jpRequired: true,
    jpSupply: true,
    emailInput: true
  },
  'ua_ar': {
    country: '阿联酋',
    stateSelect: true,
    cityInput: true,
    streetInput: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    alignRight: true
  },
  'ae_ar': {
    country: '阿联酋',
    stateSelect: true,
    citySelectInline: true,
    stateRequired: true,
    cityRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    // emailRequired: true,
    alignRight: true,
    autoFillProvince: '阿联酋'
  },
  'sa_ar': {
    country: '沙特阿拉伯',
    stateSelect: true,
    // cityInput: true,
    citySelectInline: true,
    // streetInput: true,
    stateRequired: true,
    cityRequired: true,
    // streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    // emailRequired: true,
    alignRight: true,
    autoFillProvince: '沙特阿拉伯'
  },
  'ro_ro': {
    country: '罗马尼亚',
    stateSelect: true,
    citySearch: true,
    stateRequired: true,
    cityRequired: true,
    cityPostalSelect: true,
    postalRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    autoFillProvince: 'România'
  },
  'cz_cs': {
    country: '捷克',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    address2: true
  },
  'sk_sk': {
    country: '斯洛伐克',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    address2: true
  },
  'at_de': {
    country: '奥地利',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    address2: true
  },
  'hu_hu': {
    country: '匈牙利',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    cityDataZipcode: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    nameRegexp: true
  },
  'pl_pl': {
    country: '波兰',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true
  },
  'es_es': {
    country: '西班牙',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    address2: true
  },
  'it_it': {
    country: '意大利',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    address2: true
  },
  'gr_gr': {
    country: '希腊',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true
  },
  'pt_pt': {
    country: '葡萄牙',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    address2: true
  },
  'bg_bg': {
  country: '保加利亚',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true
  },
  'hr_hr': {
    country: '克罗地亚',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    address2: true
  },
  'sl_sl': {
    country: '斯洛文尼亚',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    address2: true
  },
  'lv_lv': {
    country: '拉脱维亚',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
  },
  'lt_lt': {
    country: '立陶宛',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
  },
  'ee_ee': {
    country: '爱沙尼亚',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
  },
  'cy_cy': {
    country: '塞浦路斯',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true
  },
  'md_ro': {
    country: '摩尔多瓦',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true
  },
  'hr_eur_hr_eur': {
    country: '克罗地亚_欧元',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    address2: true
  },
  'kr_kr': {
    country: '韩国',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    address2: true
  },
  'srb_sr': {
    country: '塞尔维亚',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true
  },
  'al_sq': {
    country: '阿尔巴尼亚',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true
  },
  'tur_tr': {
    country: '土耳其',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true
  },
  'mx_mx': {
    country: '墨西哥',
    stateSelect: true,
    citySelect: true,
    streetSelect: true,
    postalSelect: true,
    postalRequired: true,
    cityDataZipcode: true,
    stateRequired: true,
    cityRequired: true,
    streetRequired: true,
    phoneRequired: true,
    nameRequired: true,
    emailInput: true,
    emailRequired: true,
    address2: true
  }
}

cl = getQueryVariable('cl', cl || 'tw_tc')
sessionStorage.setItem('cl', cl);
// cConf: 个人信息填写控制
window.cConf = templateConfigs[cl] || {}

function getQueryVariable(variable, defaultCl) {
  const ptList = Object.keys(templateConfigs);
  let query = '';
  try {
    query = decodeURIComponent(window.location.search.substring(1)).replace(/&amp;/g, '&');
  } catch (e) {
    query = window.location.search.substring(1).replace(/&amp;/g, '&');
  }
  const vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
      if(pair[0] === variable){
      if(ptList.indexOf(pair[1]) === -1) {
        return defaultCl;
      } else {
        return pair[1]
      }
    }
  }
  // window.location.search += ('&' + variable + '=' + defalut);
  return defaultCl;
}

// 用钩子函数beforeEach()对路由进行判断
router.beforeEach((to, from, next) => {
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
  if (to.meta.requireAuth) {  // 需要权限,进一步进行判断
    if (store.state.login.token) {  // 通过vuex state获取当前的token是否存在
      next();
    }
    else {    //如果没有权限,重定向到登录页,进行登录
      next({
        path: '/login',
        // query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  }
  else { //不需要权限 直接跳转
    next();
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js